import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation, useNavigate } from 'react-router-dom';
//css
import styles from './index.module.less';
const HeaderTabs = ({ className = '', headerTabs = [], }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const handleJump = (record) => {
        if (location.pathname === record.path)
            return;
        navigate(record.path);
    };
    return (_jsx("div", { className: `${styles.headerTabs} ${className}`, children: headerTabs?.map?.((item) => {
            return (_jsx("div", { className: `${styles.tabsItem} ${location.pathname === item.path ? styles.active : ''}`, onClick: () => {
                    handleJump(item);
                }, children: item.label }, item.path));
        }) }));
};
export default HeaderTabs;
